import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import ContentWrapper from 'components/layout/ContentWrapper'
import {
  Row, Col, Card, CardBody,
} from 'reactstrap'

import {
  abandonedCampaignAction,
  companyAction,
} from 'actions'
import OldAbandonedCampaignForm from 'components/parts/lineCampaign/OldAbandonedCampaignForm'

export const OldCampaignEditPage = ({ dispatch, match }) => {
  const campaignId = Number(match.params.id)

  useEffect(() => {
    dispatch(companyAction.fetchCompany())
    dispatch(abandonedCampaignAction.fetchOldAbandonedLineCampaigns())
  }, [dispatch])

  return (
    <ContentWrapper>
      <div className="content-heading">
        <div>LINEキャンペーン編集</div>
      </div>
      <Row>
        <Col xl={12}>
          <Card className="card-default">
            <CardBody>
              <OldAbandonedCampaignForm
                campaignId={campaignId}
                submitAction="update"
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </ContentWrapper>
  )
}


export default connect()(OldCampaignEditPage)
